export default __webpack_public_path__ + "static/media/COMM_VERBAL.e08a44ea.pdf";